/**
 * @Author: v_jppjpeng
 * @Date: 2023-08-03 14:10:36
 * @Explain: 标签管理
 */

export default {
  // 模板变量 - 列表
  'LABEL.MANAGE.LIST.TITLE': 'Tag list',
  'LABEL.MANAGE.CREATE.TAG': 'Create tag',
  'LABEL.MANAGE.SEARCH.PLACEHOLDER': 'Search tag',
  'LABEL.MANAGE.NAME': 'Name',

  'LABEL.MANAGE.COUNT.OF.CRATED.ON': 'Number of subscribers',
  'LABEL.MANAGE.COUNT.OF.CRATED.ON.TIPS':
    'Number of subscribers, last updated at {time}',

  'LABEL.MANAGE.COUNT.OF.CRATED.ON.NEW': 'Email: Subscribed / Total',
  'LABEL.MANAGE.COUNT.OF.CRATED.ON.NEW.TIPS':
    'Number of email subscribers, last updated at {time}',

  'LABEL.MANAGE.WHATSAPP.COUNT.OF.CRATED.ON': 'WhatsApp: Subscribed / Total',
  'LABEL.MANAGE.WHATSAPP.COUNT.OF.CRATED.ON.TIPS':
    'Number of Whatsapp subscribers, last updated at {time}',
  'LABEL.MANAGE.ADD.DATE': 'Created on',
  'LABEL.MANAGE.SEND.CAMPAIGN': 'Launch campaign',
  'LABEL.MANAGE.CREATE.BY': 'Created by',
  'LABEL.MANAGE.PREDICTIVE.TAGS': 'Predictive tag',
  'LABEL.MANAGE.PREDICTIVE.TAGS.DESC':
    'Using tens of millions of historical data points, we have developed a mathematical model to predict player behavior. This will help you anticipate on potential churn behavior and intervene in a timely manner.',
  'LABEL.MANAGE.PREDICTIVE.TAGS.VIEW.MORE': 'View more',

  // Predictive tags
  'LABEL.MANAGE.PREDICTIVE.TAGS.INFO':
    'This page uses demo data. The forecast feature is made available when in-game data is synced via API. To use this feature, access is needed to ',
  'LABEL.MANAGE.PREDICTIVE.TAGS.SEND.COMPAIGN.DIS.INFO':
    'This function is made available when in-game data is synced via API. To use this feature, access is needed to ',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.TITLE': 'Potential churn',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.PREDICTIVE': 'Predictive',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.DEMO': 'Demo',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.TERMS.TITLE': 'Tag explanation',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.TERMS.TIPS':
    "Potential churn is predicted based on players' in-game data. The campaign will only send emails to players who have shared their email address and who are subscribed.",
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.TERMS.DESC':
    'the number of players that have a high probability of churning in the next <span>{num}</span> days',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.CHARATERISTICS.TITLE':
    'Sample characteristics',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.CHARATERISTICS.DESC':
    'Players whose game campaign has decreased significantly in the past 7 days, compared to their campaign in the past. They are expected to churn if no action is undertaken.',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RECALL.TITLE': 'Expected recall',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION':
    'Retention prediction, for next <span class="color-999">{num}</span> days',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.BUBBLE':
    'Prediction data is updated daily at 4:00AM (UTC+00:00)',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.UPDATE.TIME':
    '<span class="color-999 font-size-16">Last update:</span><span class="color-333 font-size-16">{time}</span>',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.LINE.Y': 'Number of contacts',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.LINE.X': 'Days',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.NUMBER': 'Expected Retention',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.PERCENT':
    'Expected Retention Ratio',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.NUMBER.DESC':
    'The number of contacts on day 0 is the total number of players predicted to churn. Players are expected to churn gradually over time.',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.LINE.DATE': 'Days',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.LINE.DATE.DESC':
    'Day 0 represents the time since the data on this page was last updated. The potential churn is then predicted for the next 21 days.',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.SLOPE.TITLE': 'Model',
  'LABEL.MANAGE.PREDICTIVE.TAGS.RECALL.RETENTION.SLOPE.DESC':
    'Ths predictive model anticipates a high churn probability for this group of players in the next 21 days. Prevent them from churning by launching an email campaign.',

  // 规则说明
  'LABEL.MANAGE.LIST.DESC.TIPS1':
    'Quickly create campaigns based on tags. When more complex conditions are required, you can use ',
  'LABEL.MANAGE.LIST.DESC.TIPS2': 'Segments',
  'LABEL.MANAGE.LIST.DESC.TIPS3': ' to create these conditions',

  // 模板变量 - 新增、编辑
  'LABEL.MANAGE.EDIT.TAG': 'Edit tag',
  'LABEL.MANAGE.TAG.NAME': 'Tag name',
  'LABEL.MANAGE.PLEASE.ENTER.TAG.NAME': 'Enter the tag name',
  'LABEL.MANAGE.TAG.TIPS': 'Example: KOL, Influencer, or Pro gamer',

  // 删除
  'LABEL.MANAGE.LIST.DELETE.MSG': 'Delete tag',
  'LABEL.MANAGE.LIST.DEL.TIPS':
    "<b class='color-333'>'<span>{name}</span>'</b> will be permanently deleted and cannot be restored.",

  // 确认标签弹框
  'LABEL.MANAGE.TAG.BAND.TITLE': 'Update tag？',
  'LABEL.MANAGE.TAG.BAND.CONTENT.1':
    'This tag will initiate a journey. Adding this tag to a contact will immediately add them to this journey.',
  'LABEL.MANAGE.TAG.BAND.CONTENT.2': 'Journey name: ',
  'LABEL.MANAGE.TAG.BAND.CONTENT.3': '(',
  'LABEL.MANAGE.TAG.BAND.CONTENT.4': ')',
};
